import React from 'react';
import styled from 'styled-components';
import mainTop from '../../assets/main_top.jpg';
import m1Me from '../../assets/m1_me.jpeg';
import Skills from './skills';

const json = {
  en: {},
  kr: {
    description:
      '웹, 모바일, 시스템 등 다양한 영역의 도메인에서 각각의 서비스가 직면하고 있는 문제와 장애물을 언제, 어떻게 처리하는지에 대해 항상 고민하고 있습니다. 단순히 로직을 짜고 다듬는 코딩 뿐만 아니라 서비스를 이해해서 한줄 한줄 새로운걸 만들어 갑니다. 항상 함께 협업하는 동료 기획자, 디자이너, 엔지니어들과 원활한 커뮤니케이션을 통해 서비스를 확장하고, 이유 있는 개발을 하기 위해 노력하고 있습니다.',
    general:
      '모든 엔지니어가 그렇듯, 다양한 비즈니스 시스템을 만들고 수정하고, 여러 서비스들이 조화롭게 동작하도록 작업합니다. 저는 코딩만 하는 개발자가 아니라 시스템이 언제, 어떻게 문제를 해결하는지, 그리고 확장하는지 늘 고민하는 엔지니어 입니다.',
  },
};

const About = ({ lang, changeLang }) => {
  return (
    <Container>
      <section className='heading-section'>
        <div className='img-box'>
          <div className='main-top-img' />
        </div>
        <h3 className='sub-heading'>Software Engineer</h3>
        <h1 className='heading'>Create. It's about me.</h1>
        <p className='short-description'>{json[lang].description}</p>
      </section>
      <section className='general-section'>
        <div className='general-detail'>
          <h2 className='general-heading'>Daniel</h2>
          <p className='general-sub-heading'>
            Love. <span>What I do.</span>
          </p>
          <p className='general-description'>{json[lang].general}</p>
        </div>
      </section>
      <div className='img-box'>
        <div className='m1-me-img' />
      </div>
      <Skills />
    </Container>
  );
};

const Container = styled.div`
  text-align: center;
  padding-top: 48px;

  .img-box {
    display: flex;
    justify-content: center;
  }

  .main-top-img {
    box-shadow: inset 8px 8px 36px 12px #000, inset -8px -8px 36px 12px #000;
    width: 100%;
    height: 240px;
    background-image: url('${mainTop}');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .heading-section {
    margin-bottom: 120px;
  }

  .sub-heading {
    font-size: 18px;
    font-weight: normal;
    margin-bottom: 0;
    color: #f5f5f7;
  }

  .heading {
    background: radial-gradient(#eff1ff, #000);
    background-size: 100% 200%;
    background-position: 50% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 50px;
    margin: 0;
  }

  .short-description {
    color: #a1a1a6;
    text-align: center;
    font-size: 18px;
    max-width: 380px;
    margin: 18px auto;
  }

  .general-section {
    display: flex;
    justify-content: center;
  }

  .general-detail {
    text-align: left;
    max-width: 380px;

    .general-heading {
      font-size: 40px;
      margin: 0;
      text-align: left;
    }

    .general-sub-heading {
      font-size: 40px;
      color: #f5f5f7;
      font-weight: 700;
      margin: 0;

      span {
        display: block;
      }
    }

    .general-description {
      font-size: 18px;
    }
  }

  .m1-me-img {
    width: 740px;
    height: 480px;
    background-image: url('${m1Me}');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  @media only screen and (min-width: 769px) {
    .main-top-img {
      width: 540px;
      height: 360px;
    }

    .heading-section {
      margin-bottom: 150px;
    }

    .sub-heading {
      font-size: 24px;
    }

    .heading {
      font-size: 60px;
    }

    .short-description {
      font-size: 24px;
      max-width: 560px;
    }

    .general-detail {
      max-width: 560px;

      .general-heading,
      .general-sub-heading {
        font-size: 48px;

        span {
          display: inline;
        }
      }

      .general-description {
        font-size: 24px;
      }
    }
  }

  @media only screen and (min-width: 1025px) {
    .heading-section {
      margin-bottom: 170px;
    }

    .sub-heading {
      font-size: 28px;
    }

    .heading {
      font-size: 80px;
    }

    .short-description {
      font-size: 28px;
      max-width: 768px;
    }

    .general-detail {
      max-width: 768px;

      .general-heading,
      .general-sub-heading {
        font-size: 64px;
      }

      .general-description {
        font-size: 28px;
      }
    }

    .m1-me-img {
      min-width: 960px;
      background-size: contain;
      height: 740px;
    }
  }
`;

export default About;
